import gql from 'graphql-tag';

const AreaFragment = gql`
  fragment AreaFragment on AreasModel {
    id
    title
    title_short
    identify
    #время доставки от
    delivery_time_from
    #минимальный интервал от
    minimum_interval_from
    #оформите заказ до
    order_deadline
    #минимальная сумма
    minimum_amount
  }
`;

const AreasQuery = {
  getRanges: gql`
    query getRanges {
      getRanges {
        ...AreaFragment
      }
    }
    ${AreaFragment}
  `,
  getRangeById: gql`
    query getRangeById($title_short: String, $identify: String) {
      getRangeById(title_short: $title_short, identify: $identify) {
        ...AreaFragment
      }
    }
    ${AreaFragment}
  `
};

export default AreasQuery;
